<template>
  <v-row>
    <v-col cols="12" md="6" align="stretch" height="auto">
      <v-card
        color="#f4f4f4"
        class="pa-1 ma-1 mt-0"
        align="stretch"
        height="auto"
      >
        <v-card-title dense>
          NVS Net Value Score
        </v-card-title>

        <v-row align="stretch">
          <v-col cols="12">
            <v-simple-table light dense>
              <template v-slot:default>
                <thead style="background-color: #3fa9be; color: white;">
                  <tr>
                    <th
                      class="text-center"
                      style="width: 50%;color: white !important;"
                    >
                      Respuesta
                    </th>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <th
                          class="text-center"
                          v-on="on"
                          style="color: white !important;"
                        >
                          Cantidad
                          <v-icon color="white" dense>mdi-help-circle</v-icon>
                        </th>
                      </template>
                      <span>
                        En esta columna ingresá la cantidad de respuestas
                        <br />que se tiene de cada tipo.
                      </span>
                    </v-tooltip>
                    <th class="text-center" style="color: white !important;">
                      Porcentaje
                    </th>
                    <th class="text-center" style="color: white !important;">
                      Impacto
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in datos_nvs" :key="item.id">
                    <td class="ma-0 pa-0 text-center">{{ item.respuesta }}</td>
                    <td
                      class="ma-0 pa-0 text-center"
                      @click="mostrarInput(index, 1)"
                    >
                      <span
                        v-show="celda_activa != 'f' + index + 'c1'"
                        @click="mostrarInput(index, 1)"
                        style="width: 100%"
                        >{{ item.cant_respuestas | numero }}</span
                      >
                      <input
                        type="text"
                        class="campo text-center"
                        v-show="celda_activa == 'f' + index + 'c1'"
                        :ref="'f' + index + 'c1'"
                        v-model="datos_nvs[index].cant_respuestas"
                        @keydown.tab.stop.prevent="finEdicionDown(index, 1)"
                        @keyup.arrow-up.arrow-left="finEdicionUp(index, 1)"
                        @keyup.arrow-down.enter.arrow-right="
                          finEdicionDown(index, 1)
                        "
                        @keyup.esc="escape('f' + index + 'c1')"
                        @keypress="esNumero($event)"
                      />
                    </td>
                    <td class="ma-0 pa-0 text-center">
                      {{ calculaPorcentaje(index) | porcentaje }}
                    </td>
                    <td class="ma-0 pa-0 text-center">
                      {{ calculaImpacto(index) | porcentaje }}
                    </td>
                  </tr>
                  <tr>
                    <td class="ma-0 pa-0 text-center">Total</td>
                    <td class="ma-0 pa-0 text-center">
                      {{ total_respuestas }}
                    </td>
                    <td class="ma-0 pa-0 text-center">100%</td>
                    <td class="ma-0 pa-0 text-center"></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col align-self="center">
            <v-card>
              <p class="text-center" style="width: 100%;">
                Positivos:
                {{ (calculaImpacto(0) + calculaImpacto(1)) | porcentaje }}
              </p>
              <p class="text-center" style="width: 100%;">
                Negativos:
                {{ (calculaImpacto(3) + calculaImpacto(4)) | porcentaje }}
              </p>
              <p class="text-center display-1" style="width: 100%;">
                NVS:
                {{
                  ((calculaImpacto(0) +
                    calculaImpacto(1) -
                    calculaImpacto(3) -
                    calculaImpacto(4)) /
                    2)
                    | porcentaje
                }}
              </p>
            </v-card>
          </v-col>
        </v-row>
      </v-card>

      <v-card
        color="#f4f4f4"
        class="pa-1 ma-1 mt-0 caption"
        align="stretch"
        height="auto"
      >
        Si querés saber más sobre lo que hacemos en BleCX y cómo podemos
        ayudarte con tu negocio o empresa contactate con nosotros
        <a
          href="http://www.blecx.com.ar/#contacto"
          target="_blank"
          rel="noopener noreferrer"
          aria-current="page"
          >aquí</a
        >
      </v-card>
    </v-col>
    <v-col cols="12" md="6">
      <v-card color="#f4f4f4" height="auto" class="pa-1 ma-1 mt-0">
        <v-card-title class="headline">¿Qué es NVS?</v-card-title>
        <v-card-subtitle class="text-justify"
          >El NVS es la alternativa más adecuada para evaluar las relaciones
          entre las compañías. Por lo que la sugerimos para B2B como mejor
          opción. Es un indicador que se usa para determinar percepciones de
          valor sobre la propuesta de servicio de una compañía. Está orientado a
          la evaluación de valor percibido. El precio es un valor reconocido en
          decisiones de compra, sin embargo, los prescriptores en los mercados
          B2B no sólo compran por precio, también tienen en consideración los
          beneficios.</v-card-subtitle
        >
      </v-card>
      <v-card color="#f4f4f4" height="auto" class="pa-1 ma-1 mt-0">
        <v-card-title class="headline"
          >¿Cómo se obtienen los datos?</v-card-title
        >
        <v-card-subtitle class="text-justify">
          Se realizan 3 preguntas a los referentes clave de nuestros clientes,
          en este orden:
          <br />1. ¿Cómo son los beneficios percibidos comparado con otras
          compañías con productos/servicios similares? <br />2.¿Cómo son los
          precios comparados con otras compañías con productos/servicios
          similares? <br />3. ¿Cómo es el valor total percibido comparado con
          otras compañías con productos/servicios similares?
        </v-card-subtitle>
      </v-card>
      <v-card color="#f4f4f4" height="auto" class="pa-1 ma-1 mb-2">
        <v-card-title class="headline">¿Cómo se calcula?</v-card-title>
        <v-card-subtitle class="text-justify">
          Tomando únicamente los resultados de la pregunta “3”, el cálculo es el
          siguiente:
          <br />NVS = ((% de “significativamente mejor” sobre el total) x 2 + (%
          de “algo mejor” sobre el total)) - ((% de “significativamente peor”
          sobre el total) x 2 + (% de “algo peor” sobre el total)) / 2
        </v-card-subtitle>
        <v-card-text>
          <a
            href="https://www.blecx.com.ar/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <v-img
              src="../assets/logo.svg"
              width="80"
              align="bottom"
              class="ml-auto"
            ></v-img>
          </a>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      celda_activa: '',
      datos_nvs: [
        {
          respuesta: 'Significativamente mejor',
          cant_respuestas: null,
          impacto: 2,
        },
        { respuesta: 'Algo mejor', cant_respuestas: null, impacto: 1 },
        { respuesta: 'Ni mejor ni peor', cant_respuestas: null, impacto: 0 },
        { respuesta: 'Algo peor', cant_respuestas: null, impacto: 1 },
        {
          respuesta: 'Significativamente peor',
          cant_respuestas: null,
          impacto: 2,
        },
      ],
    };
  },
  filters: {
    numero: function(value) {
      value = parseInt(value);
      if (!isFinite(value) || (!value && value !== 0)) return '';
      return value;
    },
    porcentaje(value) {
      value = parseFloat(value);
      if (!isFinite(value) || (!value && value !== 0)) return '';
      return Math.round(value * 100) + '%';
    },
  },

  methods: {
    calculaPorcentaje(index) {
      return (
        parseFloat(this.datos_nvs[index].cant_respuestas) /
        parseFloat(this.total_respuestas)
      );
    },
    calculaImpacto(index) {
      return this.calculaPorcentaje(index) * this.datos_nvs[index].impacto;
    },
    mostrarInput(fila, columna) {
      var referencia = `f${fila}c${columna}`;
      this.celda_activa = referencia;
      this.$nextTick(() => {
        this.$refs[referencia][0].focus();
      });
    },
    finEdicionUp(fila, columna) {
      var prox_fila = fila > 0 ? fila - 1 : 0;
      var referencia = `f${prox_fila}c${columna}`;
      this.finEdicion(referencia);
    },
    finEdicionDown(fila, columna) {
      var prox_fila = fila < 4 ? fila + 1 : 4;
      var referencia = `f${prox_fila}c${columna}`;
      this.finEdicion(referencia);
    },
    finEdicion(referencia) {
      this.celda_activa = referencia;
      this.$nextTick(() => {
        this.$refs[referencia][0].focus();
      });
    },
    escape(referencia) {
      this.celda_activa = '';
      this.$nextTick(() => {
        this.$refs[referencia][0].blur();
      });
    },
    esNumero(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
  computed: {
    total_respuestas: function() {
      var total_respuestas = 0;
      var valor = 0;
      for (let item of this.datos_nvs) {
        valor = parseInt(item.cant_respuestas);
        if (!isFinite(valor) || (!valor && valor !== 0)) valor = 0;
        total_respuestas += valor;
      }
      return total_respuestas;
    },
  },
};
</script>

<style>
.activa {
  background-color: #eaf0f6;
}
.campo {
  width: 100%;
}
.v-card__text,
.v-card__title {
  word-break: normal; /* maybe !important  */
} /* solución a los títulos de vcard que se cortan las palabras a la mitad */
</style>
